var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#004c3f",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.642,331.949H98.034c-5.032,0-9.114,4.082-9.114,9.114s4.082,9.114,9.114,9.114h48.608 c5.032,0,9.114-4.082,9.114-9.114S151.673,331.949,146.642,331.949z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.642,404.861H98.034c-5.032,0-9.114,4.082-9.114,9.114s4.082,9.114,9.114,9.114h48.608 c5.032,0,9.114-4.082,9.114-9.114S151.673,404.861,146.642,404.861z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.629,350.177h42.532c5.032,0,9.114-4.082,9.114-9.114s-4.082-9.114-9.114-9.114h-42.532 c-5.032,0-9.114,4.082-9.114,9.114S220.598,350.177,225.629,350.177z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.161,404.861h-42.532c-5.032,0-9.114,4.082-9.114,9.114s4.082,9.114,9.114,9.114h42.532 c5.032,0,9.114-4.082,9.114-9.114S273.192,404.861,268.161,404.861z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.642,259.038H98.034c-5.032,0-9.114,4.082-9.114,9.114s4.082,9.114,9.114,9.114h48.608 c5.032,0,9.114-4.082,9.114-9.114S151.673,259.038,146.642,259.038z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.877,477.737h-51.628v-54.684h51.61c5.032,0,9.114-4.082,9.114-9.114s-4.082-9.114-9.114-9.114h-51.61v-54.684h51.61 c5.032,0,9.114-4.082,9.114-9.114s-4.082-9.114-9.114-9.114h-51.61v-54.648h51.604c5.032,0,9.114-4.082,9.114-9.114 s-4.082-9.114-9.114-9.114h-51.604V122.329c0-5.032-4.082-9.114-9.114-9.114c-5.032,0-9.114,4.082-9.114,9.114v136.709H344.11 V122.329c0-5.032-4.082-9.114-9.114-9.114s-9.114,4.082-9.114,9.114v136.709H216.515V61.57c0-5.032-4.082-9.114-9.114-9.114 s-9.114,4.082-9.114,9.114v39.494h-66.835V61.57c0-5.032-4.082-9.114-9.114-9.114s-9.114,4.082-9.114,9.114v39.494 c0,0-78.026,0.273-78.987,0.611V25.114c0-5.032-4.082-9.114-9.114-9.114s-9.114,4.082-9.114,9.114v452.658 c0,10.051,8.176,18.228,18.228,18.228l452.64-0.036c5.038,0,9.114-4.082,9.114-9.114S491.915,477.737,486.877,477.737z M417.022,477.737H344.11v-54.684h72.911V477.737z M417.022,404.825H344.11v-54.684h72.911V404.825z M417.022,277.266v54.648 H344.11v-54.648H417.022z M198.287,119.291v48.608h-66.835v-48.608H198.287z M113.224,119.291v48.608H34.237V118.68 C35.198,119.018,113.224,119.291,113.224,119.291z M34.237,186.127h164.051v91.139h127.595v200.471l-291.646,0.036V186.127z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructure);
export default __webpack_public_path__ + "static/media/structure.f9934759a05e6b7e9be2843d8745289b.svg";
export { ForwardRef as ReactComponent };